import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { isError, isLoaded } from 'src/app/shared/utils/async';

import type { RootShareRecommendations } from '../useFetchShareRecommendations';
import { useFetchShareRecommendations } from '../useFetchShareRecommendations';

export type Recommendation = NonNullable<
	NonNullable<RootShareRecommendations['facebook'] | RootShareRecommendations['reddit']>[0]
>;
export type UseShareRecommendationsReturn = ModelHookResult<{
	shareRecommendations: RootShareRecommendations;
	shouldDisplayShareRecommendations: boolean;
	shareRecommendationsLoading: boolean;
	isShareRecommendationsEnabled: boolean;
}>;

export const EMPTY_SHARE_RECOMMENDATIONS: RootShareRecommendations = {
	facebook: [],
	reddit: [],
};

export function useShareRecommendations(slug: string): UseShareRecommendationsReturn {
	const {
		data: {
			featureConfigs: { starterExperienceShareRecommendationsConfig },
		},
	} = useStarterDashboardV2PageData();

	const isShareRecommendationsEnabled = starterExperienceShareRecommendationsConfig?.isEnabled ?? false;

	const shareRecommendationsResult = useFetchShareRecommendations(slug, isShareRecommendationsEnabled);
	const shareRecommendations = isLoaded(shareRecommendationsResult)
		? shareRecommendationsResult.data
		: EMPTY_SHARE_RECOMMENDATIONS;
	const hasAnyShareRecommendations = !!shareRecommendations.reddit.length || !!shareRecommendations.facebook.length;
	const shareRecommendationsLoading =
		isShareRecommendationsEnabled && !isLoaded(shareRecommendationsResult) && !isError(shareRecommendationsResult);

	return {
		data: {
			shareRecommendations,
			shouldDisplayShareRecommendations: hasAnyShareRecommendations,
			shareRecommendationsLoading,
			isShareRecommendationsEnabled,
		},
	};
}
